module.exports = __webpack_public_path__ + "img/fiberglass.b59db72a.png";